import WorkItemCommentModelBase from '../_generated/modelBases/work-item-comment-model-base';

export default class WorkItemCommentModel extends WorkItemCommentModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
